<template>
  <div class="articleLog">
        <div class="breadcrumbBox" >  
          <span style="display: inline-block;transform: rotate(180deg);" class="return-btn" @click="handleBack()" >
            <i style="cursor: pointer;font-size: 14px;" class="iconfont icon-right"></i>
          </span> 
          <span class="articleTitle" style="transform: scaleX(-1);">All Documents
          </span>
          </div>
          <div class="articleContent">
  
        <div class="cateBox">
          <div v-if="List.length > 0" style="display: relative">
            <a-menu
              class="Amenu"
              :openKeys="openKeys"
              v-model:selectedKeys="selectedKeys"
              mode="inline"
              :inlineIndent="16"
              @openChange="openChange"
            >
              <a-sub-menu v-for="first in List" :key="first.id">
                <template slot="expandIcon"></template>
                <template slot="title">
                  <span
                    :class="[
                      'triangle-icon',
                      openKeys.includes(first.id) ? 'triangle-down' : 'triangle-right'
                    ]"
                  ></span>
                  {{ first.name }}
                </template>
                <template v-for="second in first.children">
                  <a-menu-item
                    v-if="second.children.length == 0"
                    :key="second.id"
                    @click="selectNode(second, second.children[0])"
                  >
                    <span
                      class="disable"
                      v-if="second.flag == 'disable'"
                      :title="second.name"
                      >{{ second.name }}</span
                    >
                    <span :title="second.name" v-else
                      >{{ second.name }}</span
                    >
                  </a-menu-item>
                  <a-menu-item
                    v-else-if="second.children.length == 1"
                    :key="second.children[0].id"
                    @click="selectNode(second.children[0])"
                  >
                    <span
                      class="disable"
                      v-if="second.flag == 'disable'"
                      :title="second.name"
                      >{{ second.name }}</span
                    >
                    <span :title="second.name" v-else
                      >{{ second.name }}</span
                    >
                  </a-menu-item>
                  <a-sub-menu v-else :key="second.id">
                    <template slot="title">
                      <span
                        :class="[
                          'triangle-icon',
                          openKeys.includes(second.id) ? 'triangle-down' : 'triangle-right'
                        ]"
                      ></span>
                      {{ second.name }}
                    </template>
                    <template v-for="third in second.children">
                      <a-menu-item
                        v-if="third.children.length == 0"
                        :key="third.id"
                        @click="selectNode(third)"
                      >
                        <span
                          class="disable"
                          v-if="third.flag == 'disable'"
                          :title="third.name"
                          >{{ third.name }}</span
                        >
                        <span :title="third.name" v-else
                          >{{ third.name }}</span
                        >
                      </a-menu-item>
                      <a-menu-item
                        v-else-if="third.children.length == 1"
                        :key="third.children[0].id"
                        @click="selectNode(third, third.children[0])"
                      >
                        <span
                          class="disable"
                          v-if="third.flag == 'disable'"
                          :title="third.name"
                          >{{ third.name }}</span
                        >
                        <span :title="third.name" v-else
                          >{{ third.name }}</span
                        >
                      </a-menu-item>
                      <a-sub-menu v-else :key="third.id">
                        <template slot="title">
                          <span
                            :class="[
                              'triangle-icon',
                              openKeys.includes(third.id) ? 'triangle-down' : 'triangle-right'
                            ]"
                          ></span>
                          {{ third.name }}
                        </template>
                        <a-menu-item
                          v-for="arti in third.children"
                          :key="arti.id"
                          @click="selectNode(arti)"
                        >
                          <span
                            class="disable"
                            v-if="arti.flag == 'disable'"
                            :title="arti.name"
                            >{{ arti.name }}</span
                          >
                          <span :title="arti.name" v-else
                            >{{ arti.name }}</span
                          >
                        </a-menu-item>
                      </a-sub-menu>
                    </template>
                  </a-sub-menu>
                </template>
              </a-sub-menu>
            </a-menu>
          </div>
        </div>
        </div>
       
      </div>
  </template>
  <script>
  import { categories, getIspCategories, queryArticleList, queryIspArticleList } from "@/utils/query.js";
  import { getTreeIds, getTreeNames, getTreeTitle } from "@/utils/tool.js";
  
  export default {
    name: "Mululist",
    components: {
    },
    data() {
      return {
        Searchvalue: "",
        SearchvalueKey: "",
        openKeys: [],
        selectedKeys: [],
        replaceFields: {
          title: "name",
          key: "id",
        },
        List: [],
        breadItem: {},
        articleId: "",
        articleTitle: "",
        TreeNames: [], //被选中文章的父级目录们
        showArticleContent: true,
        searchList: [],
      };
    },
    mounted() {
      this.getCate();
      console.log("fffffffff");
    },
    computed: {
    },

    methods: {
      async getCate() {
        let res = null;

          res = await getIspCategories();
      
        this.List = [];
        if (res.code == "200") {
          this.List = res.data.directoryJson;
          // 默认展开第一个节点
          if (this.List.length > 0) {
            this.openKeys = [this.List[0].id];
            // 如果第一个节点有子节点，也展开第一个子节点
            if (this.List[0].children && this.List[0].children.length > 0) {
              this.openKeys.push(this.List[0].children[0].id);
            }
          }
        }
      },
      handleBack(){
        this.$emit('handleBack');
      },
      selectNode(item, firstChild = {}) {
        console.log(item);
        this.$emit('goToArticle', item);
      },
      openChange(openKeys) {
        this.openKeys = openKeys;
      },
      sentzhugePoint() {
        let lv01 = this.TreeNames[0];
        let lv02 = this.TreeNames[1] ? this.TreeNames[1] : "";
        let lv03 = this.TreeNames[2] ? this.TreeNames[2] : "";
        this.zhugePoint("macc-help-文档中心-模块统计", {
          userid: this.GLOBAL.userid, //用户id
          lv01, //一级目录、模块
          lv02, //二级目录
          lv03, //三级目录
        });
        console.log("macc-help-文档中心-模块统计", this.TreeNames);
      },
    },
  };
  </script>
  <style scoped>

.articleLog {
    display: flex;
    flex-direction: column;
    height: 100vh; /* 占满整个视口高度 */
    overflow: hidden; /* 防止整体滚动 */
  }
  
  
  .articleContent{
    flex: 1; /* 占据剩余空间 */
    overflow-y: auto; /* 内容可滚动 */
  
    padding-bottom: 24px;
    /* 隐藏滚动条 */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    /* 确保内容在面包屑下方正确显示 */
    position: relative;
  }
  
  /* 隐藏 Webkit 浏览器的滚动条 */
  .articleContent::-webkit-scrollbar {
    display: none;
  }
  ::v-deep .ant-breadcrumb-separator {
    color: #2b6afd;
  }
  .ant-menu-item{
    color: #797E8A;
  }
  ::v-deep .ant-menu-submenu-title{
    color: #30343D;
  }
  .ArticleListBox {
    padding-top: 1rem;
    /* margin-top: 68px; */
  }
  
  .cateBox {
  
  }
  
  /* .Amenu::-webkit-scrollbar{ */
  .Amenu::-webkit-scrollbar {
    width: 5px;
  }
  .Amenu::-webkit-scrollbar-track {
    background: rgb(235, 234, 234);
    border-radius: 5px;
  }
  .Amenu::-webkit-scrollbar-thumb {
    background: rgb(199, 199, 199);
    border-radius: 5px;
  }
  .Amenu::-webkit-scrollbar-thumb:hover {
    background: rgb(199, 199, 199);
    border-radius: 5px;
  }
  .Amenu::-webkit-scrollbar-thumb:active {
    background: rgb(141, 141, 141);
    border-radius: 5px;
  }
  
  .Amenu {

    overflow-y: auto;
    overflow-x: hidden;
    background-color: transparent;
    border: none;
  }
  .Amenu::v-deep .ant-menu-submenu > .ant-menu {
    border: none;
    background-color: transparent;
  }
  .Amenu::v-deep .ant-menu-item-selected {
    border: none;
    background-color: rgba(1, 27, 70, 0.04);
    border-radius: 4px;
    color: #2b6afd;
  }
  .Amenu::v-deep .ant-menu-submenu-selected,
  .ant-menu-submenu-active,
  .ant-menu-item-active {
    color: #2b6afd;
  }
  .Amenu::v-deep .ant-menu-submenu-title:hover {
    color: #2b6afd;
  }
  .Amenu::v-deep .ant-menu-item-selected::after {
    border: none;
  }
  
  .ListBox {
    padding-left: 1rem;
    padding-bottom: 2rem;
    cursor: pointer;
    position: relative;
  }
  .ListBox .title {
    font-weight: 500;
    color: rgba(0, 0, 0, 0.9);
  }
  .disable {
    color: rgba(0, 0, 0, 0.25);
  }
  
  .breadcrumbBox {
   padding:0px 16px 0px 4px;
   color:#363A42;
   font-size: 16px;
   font-weight: 500;
  }
  .breadcrumbBox::v-deep .ant-breadcrumb > span:last-child {
    color: rgba(0, 0, 0, 0.45);
  }
  
  /* 三角形图标样式 */
  .triangle-icon {
    display: inline-block;
    width: 0;
    height: 0;
    margin-right: 8px;
    transition: transform 0.3s ease;
  }
  
  .triangle-right {
    border-left: 8px solid #797E8A;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }
  
  .triangle-down {
    border-left: 8px solid #797E8A;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    transform: rotate(90deg);
  }
  .return-btn {
  margin-right: 3px;
  padding: 4px 6px;
  border-radius: 6px;
  cursor: pointer;
  &:hover {
    background-color: #0915330a;
      }
}
  </style>
  